export var LevelName;
(function (LevelName) {
    LevelName["basic"] = "\u0431\u0430\u0437\u043E\u0432\u044B\u0439";
    LevelName["extended"] = "\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u044B\u0439";
    LevelName["advanced"] = "\u043F\u0440\u043E\u0434\u0432\u0438\u043D\u0443\u0442\u044B\u0439";
})(LevelName || (LevelName = {}));
